import type { SalesChecklistSection } from "@expert/contentful";

import { sendErrorMetric } from "@expert/cloudwatch-metrics";
import { type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useLogger } from "@/sdk";

import { ChecklistSection } from "./ChecklistSection";
import { ChecklistSectionFallback } from "./OfferChecklistFallbacks";

interface ChecklistSectionWrapperProps {
    section: SalesChecklistSection;
    onSectionComplete: (title: string) => void;
    prependSlot?: ReactNode;
    hiddenItemKeys?: string[];
}

export function ChecklistSectionWithErrorBoundary({
    section,
    onSectionComplete,
    prependSlot,
    hiddenItemKeys,
}: ChecklistSectionWrapperProps) {
    const logger = useLogger({ module: "ChecklistSectionWithErrorBoundary", supportTeam: "sales" });

    return (
        <ErrorBoundary
            onError={(error) => {
                logger.error({ error }, "Error rendering offer checklist section");
                void sendErrorMetric("OfferChecklistError", { eventSource: "Offer-Checklist" });
            }}
            fallbackRender={() => <ChecklistSectionFallback section={section} />}
        >
            <ChecklistSection
                section={section}
                onSectionComplete={onSectionComplete}
                prependSlot={prependSlot}
                hiddenItemKeys={hiddenItemKeys}
            />
        </ErrorBoundary>
    );
}
